import { blockService } from "../../index";
export const saveDocument = blockService.saveDocument;
export const saveDocuments = blockService.saveDocuments;
